module.exports = __webpack_public_path__ + "assets/img/9a61a0bedf3553fc60f33a5ae32537f7.png";